import { render, staticRenderFns } from "./TableCustomForm.vue?vue&type=template&id=0cc4b624&"
import script from "./TableCustomForm.vue?vue&type=script&lang=js&"
export * from "./TableCustomForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cc4b624')) {
      api.createRecord('0cc4b624', component.options)
    } else {
      api.reload('0cc4b624', component.options)
    }
    module.hot.accept("./TableCustomForm.vue?vue&type=template&id=0cc4b624&", function () {
      api.rerender('0cc4b624', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Finance/TableCustomForm.vue"
export default component.exports